'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
const AsyncCampaignEditPanel = Loadable({
  loader: () => import(
  /* webpackChunkName: "campaign-edit-panel" */
  'campaigns-lib/components/panels/CampaignEditPanel').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncCampaignEditPanel;